import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  width: 100%;

  border: 0;
  border-radius: 4px;
  height: 50px;
  background: #43c6ac;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  transition: background 0.2s;

  &:hover {
    background: ${shade(0.2, '#43c6ac')};
  }
`;
